import styled from 'styled-components';

export const Container = styled.div`
    max-width: 1122px;
    margin: 0 auto;
    width: calc(100% - 2rem);
`;
